export default __webpack_public_path__ + "static/media/p2.190c4a4b.png";